export const openWhatsAppChat = (title, service) => {
    const phoneNumber = "97143977746"; // Replace with your WhatsApp number
    const message = `Hello RSL. Regarding your ${title}, I'd like to inquire about ${service} options.`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
};

export const openWhatsAppChatForTravelAndTourism = (data, name) => {
    const phoneNumber = "97143977746"; // Replace with your WhatsApp number
    const message = `Hello RSL Travel & Tourism Team—I'd like to explore booking/charter/package options for ${withIndefiniteArticle(name)}.
Vehicle: ${data?.year} ${data?.brand} • Condition: ${data?.condition} • Driver: ${data?.driver}.
Could you share your available service types, pricing/commercial terms, required documents, and onboarding process?`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
};

// utils/aOrAn.ts
export function aOrAn(phrase) {
    if (!phrase) return "a";
    const s = phrase.trim();

    // First token (letters/digits/hyphen)
    const first = (s.match(/^[("'’\s-]*([A-Za-z0-9-]+)/)?.[1] || "").toLowerCase();

    // Numbers: "an 8-year-old", "an 11th-hour", "a 10-minute"
    if (/^\d/.test(first)) {
        if (/^(8|11|18|80|81|82|83|84|85|86|87|88|89)/.test(first)) return "an";
        return "a";
    }

    // Silent-H: "an hour", "an honest answer", "an heir", "an honor"
    if (/^(hour|honest|honour|honor|heir|herb\b)/.test(first)) return "an";

    // Words that start with vowel letters but have consonant "yoo"/"w" sound:
    // "a user", "a university", "a European", "a one-time fee"
    if (/^(uni([^nmd]|$)|user|use|usual|euro|one|once)/.test(first)) return "a";

    // Acronyms/initialisms (when read as letters)
    // Letters that start with a vowel sound when spoken: A, E, F, H, I, L, M, N, O, R, S, X
    const mAcr = s.match(/^([A-Z]+)(?:\b|[-.][A-Z]|[0-9])/);
    if (mAcr) {
        return /^(A|E|F|H|I|L|M|N|O|R|S|X)/.test(mAcr[1]) ? "an" : "a";
    }

    // Default: vowel letters => likely vowel sound
    if (/^[aeiou]/.test(first)) return "an";

    return "a";
}

// Convenience: returns "a/an <phrase>"
export function withIndefiniteArticle(phrase) {
    return `${aOrAn(phrase)} ${phrase}`;
}


// Reuse your withIndefiniteArticle(name) if you have it
export const openWhatsAppChatForCommercialBroker = (
    product = "Watch",
    category = "Ecommerce",
    investAmount,
    shares,
    currency = "AED"
) => {
    const phoneNumber = "97143977746"; // Replace with your WhatsApp number
    const fmt = (n) =>
        Number(n ?? 0).toLocaleString(undefined, { maximumFractionDigits: 2 });

    const message = `Hello RSL Commercial Broker Team—I'd like to discuss partnering to list ${withIndefiniteArticle(
        product
    )} under ${category}.
      Investment: ${currency} ${investAmount} for ${shares} share${Number(shares) > 1 ? "s" : ""
        }.
      Could you share commission/brokerage terms, listing & marketing support, catalog/brand requirements, payout/settlement cycle, and onboarding steps?`;

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
        message
    )}`;
    window.open(whatsappUrl, "_blank");
};

// Example:
// openWhatsAppChatForCommercialBroker({ product: "Watch", investAmount: 50000, shares: 10, currency: "AED" });
